// ===== INITIALIZE ON PAGE LOAD =====
document.addEventListener('DOMContentLoaded', function() {
  initializeProductMultiTab();
});

// ===== ACCORDION FUNCTIONALITY =====
// Handles accordion collapse/expand in tab content
function initializeAccordions(section) {
  const accordionItems = section.querySelectorAll('.accordion-item');
  
  accordionItems.forEach(item => {
    const header = item.querySelector('.accordion-header');
    if (!header) return;

    const content = item.querySelector('.accordion-content');
    if (!content) return;

    header.addEventListener('click', function() {
      const isActive = item.classList.contains('active');
      
      // Close all accordions first
      Array.prototype.map.call(accordionItems, accordion => {
        accordion.classList.remove('active');
        accordion.querySelector('.accordion-content').style.maxHeight = null;
      });
      
      // Open clicked accordion if it wasn't active
      if (!isActive) {
        item.classList.add('active');
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
}

// ===== MAIN TAB INITIALIZATION =====
// Sets up tab switching, accordions, and range sliders
function initializeProductMultiTab() {
  const sections = document.querySelectorAll('.bd-product-multi-tab');
  
  sections.forEach(section => {
    const tabItems = section.querySelectorAll('.tab-item');
    const tabContents = section.querySelectorAll('.tab-content');
    const sectionId = section.getAttribute('data-section-id');
    const storageKey = `bd-tab-${sectionId}`;
    
    // Initialize accordions within this section
    initializeAccordions(section);
    
    // ===== TAB CLICK HANDLER =====
    // Switch between tabs when clicked
    tabItems.forEach(tabItem => {
      tabItem.addEventListener('click', function() {
        const tabIndex = this.getAttribute('data-tab-index');
        
        // Remove active class from all tabs and content
        tabItems.forEach(item => item.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));
        
        // Add active class to clicked tab and corresponding content
        this.classList.add('active');
        const activeContent = section.querySelector(`.tab-content[data-content-index="${tabIndex}"]`);
        if (activeContent) {
          activeContent.classList.add('active');
        }
      });
    });

    // Set first visible tab as active
    applyDesktopTabOverride(section, storageKey);
    
    // ===== RANGE SLIDER (Day/Night Comparison) =====
    // Controls the opacity slider for light comparison
    const rangeSliders = section.querySelectorAll('.range-slider');
    
    rangeSliders.forEach(slider => {
      const tabContent = slider.closest('.tab-content');
      const nightImage = tabContent.querySelector('.night-image');
      if (!nightImage) return;

      const rangeHandle = slider.parentElement.querySelector('.range-handle');
      if (!rangeHandle) return;
      
      slider.addEventListener('input', function() {
        const sliderValue = this.value;
        const nightOpacity = sliderValue / 100;
        const handlePosition = sliderValue;
        
        // Update night image opacity and handle position
        nightImage.style.opacity = nightOpacity;
        rangeHandle.style.left = `${handlePosition}%`;
      });
    });
  });
}

// ===== SHOPIFY THEME EDITOR SUPPORT =====
// Re-initialize when section is reloaded in theme editor
document.addEventListener('shopify:section:load', function(event) {
  const section = event.target.querySelector('.bd-product-multi-tab');
  if (!section) return;
  
  initializeProductMultiTab();
});

// ===== ACTIVATE FIRST VISIBLE TAB =====
// Ensures the first non-hidden tab is always active
function applyDesktopTabOverride(section, storageKey) {
  const allTabs = section.querySelectorAll('.tab-item');
  const allContents = section.querySelectorAll('.tab-content');
  
  // Remove all active states
  allTabs.forEach(t => t.classList.remove("active"));
  allContents.forEach(c => c.classList.remove("active"));

  // Find and activate first visible tab
  const firstVisibleTab = section.querySelector('.tab-item:not([style*="display: none"])');
  const firstVisibleContent = section.querySelector('.tab-content:not([style*="display: none"])');

  if (firstVisibleTab && firstVisibleContent) {
    firstVisibleTab.classList.add("active");
    firstVisibleContent.classList.add("active");
  }
}

// ===== HANDLE WINDOW RESIZE =====
// Re-check tab visibility when switching between mobile/desktop
let previousWidth = window.innerWidth;

window.addEventListener("resize", function () {
  const newWidth = window.innerWidth;
  // Check if crossed the 768px breakpoint (mobile ↔ desktop)
  const crossedBreakpoint = (previousWidth <= 768 && newWidth > 768) || (previousWidth > 768 && newWidth <= 768);
  
  if (crossedBreakpoint) {
    const sections = document.querySelectorAll('.bd-product-multi-tab');

    sections.forEach(section => {
      const sectionId = section.getAttribute('data-section-id');
      const storageKey = `bd-tab-${sectionId}`;

      const allTabs = section.querySelectorAll('.tab-item');
      const allContents = section.querySelectorAll('.tab-content');

      // Reset active states
      allTabs.forEach(t => t.classList.remove("active"));
      allContents.forEach(c => c.classList.remove("active"));

      // Apply first visible tab
      applyDesktopTabOverride(section, storageKey);
    });
    
    // Re-check variant images for new viewport
    requestAnimationFrame(function() {
      if (typeof handleVariantChange === 'function') {
        handleVariantChange();
      }
    });
    
    previousWidth = newWidth;
  }
});

// ===== VARIANT CHANGE HANDLER =====
let handleVariantChange;

document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (!productForm) return;

  // ===== MAIN VARIANT CHANGE LOGIC =====
  // Updates images and tab visibility when variant changes
  handleVariantChange = function() {
    requestAnimationFrame(function() {
      if (!window.lightTabVariantData) return;
      
      // Get currently selected variant
      const selectedVariantInput = document.querySelector('[name="id"]');
      if (!selectedVariantInput) return;
      
      const selectedVariantId = selectedVariantInput.value;
      const variantImageData = window.lightTabVariantData[selectedVariantId];
      if (!variantImageData) return;
      
      // Check viewport size
      const isMobileView = window.innerWidth <= 768;
      
      // Check if variant has required images
      const hasDesktopImages = variantImageData.dayDesktop && variantImageData.nightDesktop;
      const hasMobileImages = variantImageData.dayMobile && variantImageData.nightMobile;
      
      let hasValidImages = false;
      
      // MOBILE: Show tab if mobile OR desktop images exist (fallback)
      // DESKTOP: Show tab ONLY if desktop images exist
      if (isMobileView) {
        hasValidImages = hasMobileImages || hasDesktopImages;
      } else {
        hasValidImages = hasDesktopImages;
      }
      
      // Update image sources if valid images exist
      if (hasValidImages) {
        updateLightImages(variantImageData);
      }
      
      // Show or hide the light tab
      toggleLightTab(hasValidImages);
      
      // Renumber tabs (1, 2, 3...) after hiding/showing
      updateTabNumbers();
    });
  };

  // ===== UPDATE LIGHT COMPARISON IMAGES =====
  // Switches day/night images based on selected variant
  function updateLightImages(variantImageData) {
    const dayImageElement = document.querySelector('.comparison-image.day-img');
    const nightImageElement = document.querySelector('.comparison-image.night-img');
    const isMobileView = window.innerWidth <= 768;
    
    // Use mobile images on mobile, fall back to desktop if mobile not available
    if (dayImageElement) {
      dayImageElement.src = isMobileView ? (variantImageData.dayMobile || variantImageData.dayDesktop) : variantImageData.dayDesktop;
    }
    
    if (nightImageElement) {
      nightImageElement.src = isMobileView ? (variantImageData.nightMobile || variantImageData.nightDesktop) : variantImageData.nightDesktop;
    }
  }
  
  // ===== SHOW/HIDE LIGHT TAB =====
  // Toggles light tab visibility based on image availability
  function toggleLightTab(hasValidImages) {
    const lightTab = document.querySelector('.tab-item[data-block-type="light"]');
    const lightTabContent = document.querySelector('.tab-content[data-block-type="light"]');
    
    if (!lightTab || !lightTabContent) return;
    
    // Show or hide light tab
    if (hasValidImages) {
      lightTab.style.display = '';
      lightTabContent.style.display = '';
    } else {
      lightTab.style.display = 'none';
      lightTabContent.style.display = 'none';
    }
    
    // Reset active states and activate first visible tab
    const sections = document.querySelectorAll('.bd-product-multi-tab');
    sections.forEach(section => {
      const allTabs = section.querySelectorAll('.tab-item');
      const allContents = section.querySelectorAll('.tab-content');
      
      allTabs.forEach(t => t.classList.remove('active'));
      allContents.forEach(c => c.classList.remove('active'));
      
      const firstVisibleTab = section.querySelector('.tab-item:not([style*="display: none"])');
      const firstVisibleContent = section.querySelector('.tab-content:not([style*="display: none"])');
      
      if (firstVisibleTab && firstVisibleContent) {
        firstVisibleTab.classList.add('active');
        firstVisibleContent.classList.add('active');
      }
    });
  }
  
  // ===== UPDATE TAB NUMBERS =====
  // Renumbers visible tabs (1, 2, 3...) after hiding/showing tabs
  function updateTabNumbers() {
    const allTabs = document.querySelectorAll('.tab-item');
    let currentNumber = 1;
    
    allTabs.forEach(function(tab) {
      const numberElement = tab.querySelector('.tab-number');
      if (tab.style.display !== 'none' && numberElement) {
        numberElement.textContent = currentNumber;
        currentNumber = currentNumber + 1;
      }
    });
  }

  // ===== EVENT LISTENERS =====
  // Listen for variant changes via form change
  productForm.addEventListener('change', handleVariantChange);
  
  // Listen for variant changes via color button clicks
  const colorButtons = document.querySelectorAll('[data-option-buttons] button');
  colorButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      setTimeout(handleVariantChange, 50);
    });
  });
  
  // Run on initial page load
  requestAnimationFrame(handleVariantChange);
});
